import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../../shared/models/content.models';
import type { EffectivePermissions, PermissionLevel, PermissionModuleDef, RoleModulePermission } from './permission.types';

export type RolePermissionSummary = {
  roleKey: string;
  isLocked: boolean;
  moduleAccessCount: number;
  totalModules: number;
  version: number;
  updatedAt?: string | null;
  updatedBy?: string | null;
};

export type RolePermissionDetail = {
  roleKey: string;
  isLocked: boolean;
  modules: RoleModulePermission[];
  version: number;
  updatedAt?: string | null;
  updatedBy?: string | null;
  effective: EffectivePermissions;
};

export type PermissionRegistryResponse = {
  version: number;
  levels: Array<{ value: PermissionLevel; label: string }>;
  modules: PermissionModuleDef[];
};

@Injectable({ providedIn: 'root' })
export class RolePermissionsApiService {
  constructor(private readonly api: ApiService) {}

  getRegistry() {
    return this.api
      .get<ApiEnvelope<PermissionRegistryResponse>>('platform/role-permissions/registry')
      .pipe(map((r) => r.data));
  }

  listSummaries() {
    return this.api
      .get<ApiEnvelope<RolePermissionSummary[]>>('platform/role-permissions')
      .pipe(map((r) => r.data));
  }

  getByRoleKey(roleKey: string) {
    return this.api
      .get<ApiEnvelope<RolePermissionDetail>>(`platform/role-permissions/${roleKey}`)
      .pipe(map((r) => r.data));
  }

  updateByRoleKey(roleKey: string, modules: RoleModulePermission[]) {
    return this.api
      .put<ApiEnvelope<RolePermissionDetail>>(`platform/role-permissions/${roleKey}`, { modules })
      .pipe(map((r) => r.data));
  }
}
